import { FC } from 'react';

import ErrorPage, { ErrorPageProps } from './ErrorPage';

const NotFoundPage: FC<ErrorPageProps> = ({ standalonePage = true, ...restProps }) => (
  <ErrorPage standalonePage={standalonePage} {...restProps} />
);

export default NotFoundPage;
